<template>
  <div class="home-view">
    <ul class="home-view__menu list-unstyled" v-if="isRecetaCheque">
      <router-link
        v-if="isMedic && !disablePrescriptions"
        tag="li"
        to="/medication-requests/create"
        class="home-view__menu-item">
        <app-media-object>
          <template v-slot:icon>
            <i class="fas fa-plus-square" />
          </template>
          <template v-slot:info>
            Ingresar Prescripción
          </template>
          <div>Receta Cheque Electrónica</div>
        </app-media-object>
      </router-link>
    </ul>
    <ul class="home-view__menu list-unstyled" v-else>
      <router-link
        v-if="isMedic && !disablePrescriptions"
        tag="li"
        to="/medication-requests/create"
        class="home-view__menu-item">
        <app-media-object>
          <template v-slot:icon>
            <i class="fas fa-plus-square" />
          </template>
          <template v-slot:info>
            Ingresar Prescripción
          </template>
          <div>Receta Electrónica</div>
        </app-media-object>
      </router-link>
       <router-link
        v-if="isMedic && !disablePrescriptions"
        tag="li"
        to="/medication-requests-foreign/create"
        class="home-view__menu-item">
        <app-media-object>
          <template v-slot:icon>
            <i class="fas fa-plus-square" />
          </template>
          <template v-slot:info>
            Prescripción para Extranjeros
          </template>
          <div>Extranjeros sin Run</div>
        </app-media-object>
      </router-link>
      <router-link
        v-if="isMedic && !disablePrescriptions"
        tag="li"
        to="/medication-requests"
        class="home-view__menu-item">
        <app-media-object>
          <template v-slot:icon>
            <i class="fas fa-list" />
          </template>
          <template v-slot:info>
            Ver Prescripciones
          </template>
          <div>Historial de Prescripciones</div>
        </app-media-object>
      </router-link>
      <router-link v-if="false"
        tag="li"
        to="/printed-folio-requests"
        class="home-view__menu-item">
        <app-media-object>
          <template v-slot:icon>
            <i class="fas fa-print" />
          </template>
          <template v-slot:info>
            Solicitud de Folios
          </template>
          <div>Receta Gráfica</div>
        </app-media-object>
      </router-link>
    </ul>
  </div>
</template>

<script>
import AppMediaObject from '@/components/AppMediaObject';

export default {
  name: 'Home',
  components: {
    AppMediaObject
  },
  computed: {
    isMedic() {
      return this.$store.getters.hasRole('medic');
    },
    disablePrescriptions() {
      return this.$store.state.disablePrescriptions;
    },
    isMedicalCenter() {
      return this.$store.getters.hasRole('medical_center');
    },
    isRecetaCheque(){
      return process.env.VUE_APP_RECETA_CHEQUE == "true";
    }
  }
};
</script>

<style lang="scss">
  .home-view {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (min-width: map-get($--grid-breakpoints, "md")) {
      min-height: 100%;
    }
    &__title {
      color: $--color-white;
      margin: $--spacing-4 0;
    }
    &__menu {
      display: flex;
      padding: 5%;
      @media (min-width: 500px){
        padding: 60px 90px !important;
      }


      flex-direction: column;
      background-color: #fff;
      border-radius: $--border-radius-base;
    }

    &__menu-item {
      margin-bottom: $--spacing-6;
      cursor: pointer;
      transition: transform $--transition-time ease;
      &:last-child {
        margin-bottom: 0;
      }

      &.disabled {
        .card {
          position: relative;

          &:after {
            content: " ";
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.3);
          }
        }
        &:hover {
          transform: none;
        }
      }
      .card {
        padding: $--spacing-6;
      }
    }
  }

</style>
